import React, { forwardRef, useCallback } from 'react'
import { TreeSelect as AntTreeSelect } from 'antd'
import { isNil, isUndefined, noop, size } from 'lodash'
import PropTypes from 'prop-types'

import { SIZES } from '../../constants'
import { handleTreeSelectDropdownSearchHighlights } from '../../helpers'
import { antFormItemNamePropType } from '../../prop-types'

const TreeSelect = (
  {
    name,
    treeData,
    onChange,
    value,
    treeCheckable,
    maxSelectableOptions,
    treeNodeLabelProp,
    maxTagCount,
    ...rest
  },
  ref,
) => {
  const handleOnChange = useCallback(
    value => {
      if (!isNil(maxSelectableOptions) && size(value) > maxSelectableOptions) {
        return
      }

      onChange(isUndefined(value) ? null : value)
    },
    [maxSelectableOptions, onChange],
  )

  const maxTagPlaceholder = useCallback(
    omittedValues => `and ${size(omittedValues)} more selected`,
    [],
  )

  return (
    <AntTreeSelect
      ref={ref}
      treeNodeLabelProp={treeNodeLabelProp}
      onChange={handleOnChange}
      value={value}
      treeCheckable={treeCheckable}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      dropdownRender={handleTreeSelectDropdownSearchHighlights}
      treeData={treeData}
      treeNodeFilterProp="title"
      showCheckedStrategy={treeCheckable ? AntTreeSelect.SHOW_ALL : undefined}
      dropdownMatchSelectWidth={SIZES.DROPDOWN_MIN_WIDTH}
      {...rest}
    />
  )
}

TreeSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  onChange: PropTypes.func,
  name: antFormItemNamePropType,
  treeData: PropTypes.array.isRequired,
  treeCheckable: PropTypes.bool,
  maxSelectableOptions: PropTypes.number,
  treeNodeLabelProp: PropTypes.string,
  maxTagCount: PropTypes.oneOf([PropTypes.number, 'responsive']),
}

TreeSelect.defaultProps = {
  value: undefined,
  onChange: noop,
  treeCheckable: false,
  name: undefined,
  maxSelectableOptions: undefined,
  treeNodeLabelProp: undefined,
  maxTagCount: 4,
}

export default forwardRef(TreeSelect)
